// Small shared UI helpers for the portal
export const StatusBadge = ({ status }) => {
  const map = {
    ativo: { label: "Ativo", c: "bg-emerald-50 text-emerald-700 border-emerald-200" },
    aprovado: { label: "Aprovado", c: "bg-emerald-50 text-emerald-700 border-emerald-200" },
    aprovada: { label: "Aprovada", c: "bg-emerald-50 text-emerald-700 border-emerald-200" },
    pendente: { label: "Pendente", c: "bg-amber-50 text-amber-700 border-amber-200" },
    inativo: { label: "Inativo", c: "bg-rose-50 text-rose-700 border-rose-200" },
    reprovado: { label: "Reprovado", c: "bg-rose-50 text-rose-700 border-rose-200" },
    arquivada: { label: "Arquivada", c: "bg-slate-100 text-slate-600 border-slate-200" },
  };
  const cfg = map[status?.toLowerCase()] || {
    label: status || "—",
    c: "bg-slate-100 text-slate-700 border-slate-200",
  };
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-[11px] uppercase tracking-wide ${cfg.c}`}
    >
      {cfg.label}
    </span>
  );
};

export const Card = ({ children, className = "", testid }) => (
  <div
    data-testid={testid}
    className={`${/(^|\s)bg-/.test(className) ? "" : "bg-white "}border border-slate-200 rounded-md ${className}`}
  >
    {children}
  </div>
);

export const PageHeader = ({ title, subtitle, actions }) => (
  <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6">
    <div>
      <h1 className="font-serif-display text-3xl md:text-4xl leading-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-2 text-sm text-slate-600 max-w-2xl">{subtitle}</p>
      )}
    </div>
    {actions && <div className="flex items-center gap-2">{actions}</div>}
  </div>
);

export const EmptyState = ({ title, hint }) => (
  <div className="bg-white border border-dashed border-slate-300 rounded-md p-10 text-center">
    <div className="font-serif-display text-xl text-slate-700">{title}</div>
    {hint && <div className="mt-2 text-sm text-slate-500">{hint}</div>}
  </div>
);

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    // Bare date strings (YYYY-MM-DD) are parsed as UTC midnight by
    // `new Date(...)`, which shifts a day backward when rendered in
    // negative-UTC timezones (e.g. America/Sao_Paulo → -3h). Format
    // them directly to avoid the timezone drift.
    const bare = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    if (bare) {
      return `${bare[3]}/${bare[2]}/${bare[1]}`;
    }
    const d = new Date(iso);
    return d.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};
